var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.url)?_c('img',{staticClass:"neko-image-preview",attrs:{"src":_vm.url}}):_c('div',{staticClass:"neko-image-preview neko-empty"})}
var staticRenderFns = []

export { render, staticRenderFns }